<template>
    
        
        <div class="menuhead">
            <div ref="hamburger" class="burgerwrap" role="button">
                <button
                    aria-label="Meny"
                    class="hamburger hamburger--collapse"
                    type="button"
                    :class="burgerClass"
                >
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
    
</template>

<script setup>
import { computed, ref } from 'vue';



const props = defineProps({
    active: {
        type: Boolean,
        default: true
    }
});



const burgerClass = computed(() => {
    return props.active ? 'is-active' : '';
});


</script>

<style scoped>
.menubutton {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 200;
    pointer-events: all;
    cursor: pointer;
    padding: 0px 0px 0px 0px;
}

.mobile .menubutton {
    padding: 5px 20px 10px 0px;
}

.menuhead {
    cursor: pointer;
}

.mobile .menuhead {
}
</style>
